import { RegisterEntryRequest } from '@/domain/entities/reviewRequest/registerEntryRequest'
import { ReviewRequestItem } from '@/domain/entities/reviewRequest/reviewRequestItem'
import { ReviewRequestRepository } from '@/domain/repositories/reviewRequest/reviewRequestRepository'
import { DisplayLanguageType } from '@/domain/value_objects/language/displayLanguageType'

export class ReviewRequestUseCase {
  constructor(private repository: ReviewRequestRepository) {}

  async getReviewRequestList(status: string, displayLanguage: DisplayLanguageType): Promise<ReviewRequestItem[]> {
    try {
      return await this.repository.getReviewRequestList(status, displayLanguage)
    } catch (error) {
      console.error(`Error in ReviewRequestUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }

  async postRegisterEntry(request: RegisterEntryRequest): Promise<void> {
    try {
      await this.repository.postRegisterEntry(request)
    } catch (error) {
      console.error(`Error in ReviewRequestUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }
}
